export class ObjectHelper {
  public static map<T, U>(
    object: { [key: string]: T },
    mapper: (value: [string, T], index: number, array: [string, T][]) => [string, U],
  ): { [key: string]: U } {
    return Object.fromEntries(Object.entries(object).map(mapper));
  }
}
